module.exports = __webpack_public_path__ + "static/media/freedial-fwd.a50279bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/freedial-fwd.svg
// module id = 491
// module chunks = 11